import { render, staticRenderFns } from "./yxl-bind.vue?vue&type=template&id=1300d309&scoped=true&"
import script from "./yxl-bind.vue?vue&type=script&lang=js&"
export * from "./yxl-bind.vue?vue&type=script&lang=js&"
import style0 from "./yxl-bind.vue?vue&type=style&index=0&id=1300d309&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1300d309",
  null
  
)

export default component.exports